export default __webpack_public_path__ + "3f7c84a844a7a8685d8cc58e47b63dc4.png";